import React, { useState, useContext } from 'react';
import { Box, Typography, TextField, Button, Container, Paper, Alert, InputAdornment, IconButton } from '@mui/material';
import { Link as MuiLink } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import Header from "../../components/Header";
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import Cookies from 'js-cookie';
import { AuthContest } from "../utils/AuthContext";
import { Helmet } from 'react-helmet';

import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';

const LoginForm = () => {
  const navigate = useNavigate();
  const [credentials, setCredentials] = useState({ email: '', password: '' });
  const [showPassword, setShowPassword] = useState(false);
  const { loading, error, dispatch } = useContext(AuthContest);

  const handleChange = (e) => {
    const { id, value } = e.target;
    setCredentials((prev) => ({ ...prev, [id]: value }));
  };

  const handleClickShowPassword = () => {
    setShowPassword((show) => !show);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    dispatch({ type: 'LOGIN_START' });
    try {
      const res = await axios.post('https://api.komorotel.com/api/auth/login', {
        email: credentials.email,
        password: credentials.password,
      }, {
        headers: { 'Content-Type': 'application/json' },
      });

      Cookies.set('access_token', res.data.access_token, {
        path: '/',
        secure: true,
        sameSite: 'None',
        domain: '.komorotel.com',
      });

      dispatch({ type: 'LOGIN_SUCCESS', payload: res.data });
      navigate('/');
    } catch (err) {
      dispatch({ type: 'LOGIN_ERROR', payload: err.response?.data });
    }
  };

  return (
    <>
      <Helmet>
        <title>Connexion - Komorotel</title>
        <meta name="description" content="Connectez-vous à votre compte Komorotel pour gérer vos réservations d’hôtels aux Comores." />
        {/* Meta Open Graph et Twitter ici */}
      </Helmet>

      <Header disabled={true} />
      <Container maxWidth="sm" sx={{ mt: 7 }}>
        <Paper
          elevation={3}
          sx={{
            p: 4,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          <Typography variant="h5" fontWeight="bold" gutterBottom>
            Se connecter ou créer un compte
          </Typography>
          <Typography variant="body2" color="textSecondary" gutterBottom>
            Entrez vos informations afin de pouvoir profiter de nos services
          </Typography>

          <Box
            component="form"
            noValidate
            autoComplete="off"
            onSubmit={handleSubmit}
            sx={{ width: '100%', mt: 3 }}
          >
            <TextField
              id="email"
              label="Adresse e-mail"
              variant="outlined"
              fullWidth
              required
              margin="normal"
              onChange={handleChange}
            />

            <TextField
              id="password"
              label="Mot de passe"
              variant="outlined"
              type={showPassword ? 'text' : 'password'}
              fullWidth
              required
              margin="normal"
              onChange={handleChange}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      onClick={handleClickShowPassword}
                      edge="end"
                      color="primary"
                      aria-label={showPassword ? 'Masquer le mot de passe' : 'Afficher le mot de passe'}
                    >
                      {showPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                )
              }}
            />

            <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 1 }}>
              <MuiLink
                component={RouterLink}
                to="/forgot-password"
                underline="hover"
                sx={{ fontSize: '0.9rem', fontWeight: '500' }}
                color="primary"
              >
                Mot de passe oublié ?
              </MuiLink>
            </Box>

            {error && (
              <Alert severity="error" sx={{ mt: 2 }}>
                {error.message || "Une erreur est survenue."}
              </Alert>
            )}

            <Button
              type="submit"
              color="primary"
              variant="contained"
              fullWidth
              sx={{ mt: 3 }}
              disabled={loading}
            >
              {loading ? 'Chargement...' : 'Confirmer'}
            </Button>
          </Box>
        </Paper>
      </Container>
    </>
  );
};

export default LoginForm;
